import "./series.css";
const series = [1, 2, 3];

function openFullscreen() {
  const elem=document.querySelector('body')
  if (elem.requestFullscreen) {
    elem.requestFullscreen();
  } else if (elem.webkitRequestFullscreen) { /* Safari */
    elem.webkitRequestFullscreen();
  } else if (elem.msRequestFullscreen) { /* IE11 */
    elem.msRequestFullscreen();
  }
}

function Series({ history }) {
  const handleClick = (serieNbr) => {
    sessionStorage.setItem("__users_answers__", JSON.stringify([]));
    history.push(`/serie/${serieNbr}/question/1`);
    openFullscreen()
  };
  return (<div id="series-page">
    <h1>لائحة السلاسل</h1>
    <div id="series-list">
      {series.map((serieNbr) => (
        <div key={serieNbr} className="serie-item" onClick={() => handleClick(serieNbr)}>
          <h2>Serie {serieNbr} السلسلة</h2>
        </div>
      ))}
    </div>
  </div>);
}

export default Series;
